import { isAvigilonAltaCamera } from "@/utils/cameraSnooze";

type TalkdownCamera = {
  id?: string | number | null;
  cameraPlayerId?: number | null;
  general_description?: string | null;
  location_description?: string | null;
  username?: string | number | null;
};

export type QueueTalkdownMode = "integration" | "orchid" | "legacy";

export function isAltaVirtualRoutingCamera(camera: TalkdownCamera | null | undefined): boolean {
  const generalDescription = String(camera?.general_description ?? "");
  const username = String(camera?.username ?? "");

  return generalDescription.includes("AvigilonAlta NonVideoRouting:") || username.startsWith("NON_VIDEO_ROUTING_");
}

export function resolveQueueTalkdownMode(camera: TalkdownCamera | null | undefined): QueueTalkdownMode {
  if (camera?.cameraPlayerId === 6 || isAvigilonAltaCamera(camera)) {
    return "integration";
  }

  if (camera?.cameraPlayerId === 5) {
    return "orchid";
  }

  return "legacy";
}

export function resolveTalkdownCameraId(selectedCamera: TalkdownCamera | null | undefined, alertCamera: TalkdownCamera | null | undefined): string {
  const camera = [selectedCamera, alertCamera].find(candidate => candidate?.id != null && !isAltaVirtualRoutingCamera(candidate));

  return camera?.id?.toString() ?? "";
}
